export const DS_TABLE_CLASSES = {
  Root: "ds-table",
  Table: "ds-table__table",
  Cell: "ds-table__cell",
  Header: "ds-table__header",
  Sort: "ds-table__sort",
  SortIcon: "ds-table__sort-icon",
  SortIconActive: "ds-table__sort-icon--active",
  SortIconAscending: "ds-table__sort-icon--ascending",
  RightBorder: "ds-table__cell--right-border",
  StickyHeader: "ds-table--sticky-header",
  StickyFirstColumn: "ds-table--sticky-first-column",
  StickyLastColumn: "ds-table--sticky-last-column",
} as const;
